import {useIonToast} from "@ionic/react";

export function withIonToast(Component) {
    return function WrappedComponent(props) {
        const [presentToast] = useIonToast();
        return <Component {...props} presentToast={presentToast} />;
    }
}